export default {
  consult: {},
  agenda: {},
  documentsConsulted: [],
};
